var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Checkbox, Textfield } from "syf-component-library/ui/atoms";
import { Body, H5, Small } from "syf-component-library/ui/typography";
import { IMAGE_ASSETS } from "../../../../const/assets";
import { useCreditAccounts } from "../../../../const/syfApiQueries";
import { useConfig } from "../../../../hooks/useConfig";
import getTranslation from "../../../../strings/getTranslations";
import validateNumberInput from "../../EditProfile/IncomeSection/helpers";
import { formatCurrency } from "../helpers/helpers";
import { CheckboxContainer, DisclosureContainer, Image, IncomeCaptureContainer, } from "./subComponents";
var IncomeCaptureModalContent = function () {
    var _a;
    var _b = useState(false), inputHasBeenFocused = _b[0], setInputHasBeenFocused = _b[1];
    var _c = useState(false), shouldApplyToAllAccounts = _c[0], setShouldApplyToAllAccounts = _c[1];
    var _d = useState(false), shouldFormatInput = _d[0], setShouldFormatInput = _d[1];
    var profileConfig = useConfig();
    var assets = profileConfig.hosts.assets;
    var _e = useFormContext(), control = _e.control, isSubmitting = _e.formState.isSubmitting;
    var accountQuery = useCreditAccounts(profileConfig).data;
    var t = getTranslation().t;
    var cashImage = "".concat(assets).concat(IMAGE_ASSETS.CASH);
    return (_jsxs(IncomeCaptureContainer, { children: [_jsx(Image, { src: cashImage, alt: "" }), _jsx(H5, __assign({ weight: "bold" }, { children: t("incomeCapture.modal.content.title", { cardName: "TruRetail" }) })), _jsx(Body, { children: t("incomeCapture.modal.content.subtitle") }), _jsx(Controller, { name: "income", control: control, render: function (_a) {
                    var _b = _a.field, name = _b.name, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, error = _a.fieldState.error;
                    return (_jsx(Textfield, { id: "income", name: name, type: "text", width: "100%", placeholder: t("labels.annualIncome"), error: t((error === null || error === void 0 ? void 0 : error.message) || ""), isDisabled: isSubmitting, onChange: onChange, onBlur: function () {
                            onBlur();
                            setShouldFormatInput(true);
                        }, value: shouldFormatInput ? formatCurrency(value) : value, maxLength: 7, inputMode: "numeric", onKeyPress: function (event) {
                            validateNumberInput(event);
                        }, onFocus: function () {
                            setShouldFormatInput(false);
                            setInputHasBeenFocused(true);
                        }, errorIcon: _jsx(FontAwesomeIcon, { icon: faTriangleExclamation }) }));
                } }), !!((_a = accountQuery === null || accountQuery === void 0 ? void 0 : accountQuery.accounts) === null || _a === void 0 ? void 0 : _a.length) && (_jsx(CheckboxContainer, { children: _jsx(Checkbox, __assign({ onChange: function () {
                        setShouldApplyToAllAccounts(function (shouldApplyToAllAccountsState) {
                            return !shouldApplyToAllAccountsState;
                        });
                    }, isChecked: shouldApplyToAllAccounts }, { children: t("incomeCapture.modal.content.checkbox") })) })), inputHasBeenFocused && (_jsxs(DisclosureContainer, { children: [_jsx(Small, { children: t("incomeCapture.modal.content.body.firstParagraph") }), _jsx(Small, { children: t("incomeCapture.modal.content.body.secondParagraph") }), _jsxs(Small, { children: [_jsx("strong", { children: t("incomeCapture.modal.content.body.WIResidents") }), " ", t("incomeCapture.modal.content.body.thirdParagraph")] })] }))] }));
};
export default IncomeCaptureModalContent;
